import { privateAxios } from "@/common/api/axios";
import { defaultTransformerResponse } from "@/common/constants/defaultTransformerResponse.constant";
import { Mapper } from "@/common/services/mapper";
import { MetaResponse } from "@/common/types/metaResponse";
import { keepPreviousData, useQuery } from "@tanstack/react-query";

type UseGeoStatesProps<T> = {
  filters?: {
    search?: string;
  };
  mapper?: (data: any) => T,
};

export const useGeoStates = <T,>({
  filters: { search = '' } = {},
  mapper = Mapper.default<T>(),
}: UseGeoStatesProps<T>) => {
  const {
    data: { data, meta } = defaultTransformerResponse<T>(),
    ...rest
  } = useQuery({
    queryKey: ['states', search],
    queryFn: () => {
      return privateAxios.get(`/geo/states`, {
        params: {
          search
        }
      });
    },
    select: (data: { data: { data: any[], meta: MetaResponse; }; }) => {
      return {
        data: mapper(data?.data?.data),
        meta: data?.data?.meta,
      };
    },
    placeholderData: keepPreviousData,
  });

  return { data, meta, ...rest };
};